import { render, staticRenderFns } from "./AdministrationRoleDetailManage.vue?vue&type=template&id=8c8ca430&scoped=true"
import script from "./AdministrationRoleDetailManage.vue?vue&type=script&lang=js"
export * from "./AdministrationRoleDetailManage.vue?vue&type=script&lang=js"
import style0 from "./AdministrationRoleDetailManage.vue?vue&type=style&index=0&id=8c8ca430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8ca430",
  null
  
)

export default component.exports